import { Rank, DispatchGroup } from '../api-types';
import { types } from './types';

export interface RankState {
    ranks: Rank[];
    area?: any;
    dispatchGroups: DispatchGroup[];
}

const initialState: RankState = {
    ranks: [],
    area: undefined,
    dispatchGroups: [],
};

const reducer = (state = initialState, action): RankState => {
    const payload = action.payload;
    const parameters = action.parameters;
    const id = parameters ? parameters.id : 0;

    switch (action.type) {
        case types.GET_RANKS:
            return { ...state, ranks: payload };

        case types.GET_RANK:
            if (state.ranks.some((rank) => rank.id === id)) {
                return {
                    ...state,
                    ranks: state.ranks.map((rank) => (rank.id === id ? payload : rank)),
                };
            }
            return { ...state, ranks: [...state.ranks, payload] };

        case types.GET_AREA:
            return { ...state, area: payload };

        case types.GET_DISPATCH_GROUP:
            return { ...state, dispatchGroups: payload };

        case types.CREATE_RANK:
            return {
                ...state,
                ranks: [...state.ranks, payload],
            };

        default:
            return state;
    }
};

export default reducer;
